import { connect } from 'react-redux';
import MyTaskPlanner from './MyTaskPlanner';

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MyTaskPlanner);
